export default function FindReplaceModal({
  findColorIndex,
  customPalette,
  isPro,
  onClose,
  onReplace,
  getSymbolColor,
}) {
  if (findColorIndex === null) return null;

  const colorToReplace = customPalette[findColorIndex];
  if (!colorToReplace) return null;

  if (!isPro) return null;

  return (
    <div className="modal-backdrop">
      <div className="modal settings-modal">
        <div className="modal-header">
          <h2>Find and Replace</h2>
          <button className="icon-btn" onClick={onClose}>
            Close
          </button>
        </div>
        <div className="modal-body">
          <h3>Replace All Instances Of:</h3>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              marginBottom: "20px",
            }}
          >
            <div
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: colorToReplace.hex,
                border: "1px solid var(--border)",
              }}
              title={`${colorToReplace.code} ${colorToReplace.name}`}
            >
              <span
                style={{
                  fontSize: "30px",
                  lineHeight: "50px",
                  display: "block",
                  textAlign: "center",
                  color: getSymbolColor(colorToReplace.hex),
                }}
              >
                {colorToReplace.symbol}
              </span>
            </div>
            <p style={{ margin: 0 }}>
              {colorToReplace.code} ({colorToReplace.name})
            </p>
          </div>

          <hr />

          <h3>Replace With (Select a color):</h3>
          <div
            className="mypalette-row-scroll-container"
            style={{ maxHeight: "30vh", overflowY: "auto" }}
          >
            <div className="mypalette-row" style={{ flexWrap: "wrap" }}>
              {customPalette.map((color, index) => (
                <div key={color.code || index} className="mypalette-item">
                  <button
                    className="swatch"
                    style={{
                      background: color.hex,
                      boxShadow:
                        index === findColorIndex
                          ? "0 0 0 4px #dc2626"
                          : "none",
                    }}
                    onClick={() => onReplace(index)}
                    title={`Replace with ${color.code} ${color.name}`}
                    disabled={index === findColorIndex}
                  >
                    <span
                      className="swatch-symbol"
                      style={{
                        fontSize: "25px",
                        lineHeight: "1",
                        transform: "translateY(-1px)",
                        color: getSymbolColor(color.hex),
                      }}
                    >
                      {color.symbol || ""}
                    </span>
                  </button>
                  <div className="mypalette-code">{color.code}</div>
                  {index === findColorIndex && (
                    <div className="mypalette-code" style={{ color: "#dc2626" }}>
                      Current
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
          <p className="hint warning">
            This action is permanent (undo is available via Back). It will
            replace the color across all layers.
          </p>
        </div>
        <div className="modal-actions">
          <button className="btn" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
